// extracted by mini-css-extract-plugin
export default {"root":"DocumentsSearch_root__4GRxY","panel":"DocumentsSearch_panel__n2wNi","result":"DocumentsSearch_result__gUwBA","list":"DocumentsSearch_list__V0E-S"};